module.exports = __webpack_public_path__ + "static/media/age_3.90f4de54.svg";